<template>
    <router-link class="sidenav-item" tag="div" active-class="active" :to="'/report/' + child.path" :exact="true">
        <div class="row sidenav-link pl-4">
            <div class="col-2">
                <button v-if="show_favorite_button" @click="favorite_status_changer(child.report_id)" style="background-color:transparent; border-color:transparent; outline:transparent">
                    <i class="fa fa-star" :style="[isFavorite ? { 'color': '#FFD700', 'text-shadow': '0px 0px 10px #FFFF00' } : { 'color': '#555555' }]" aria-hidden="true"></i>
                </button>
            </div>
            <div class="col-10">
                <a class="sidenav-link" style="padding:0px;" :style="[$route.path.split('/')[2] == child.path ? { 'color': '#e84c64' } : {}]">
                    <i class="sidenav-icon" v-if="child.icon" :class="child.icon"></i>
                    <div>
                        <slot>{{ $t(child.title) }}</slot>
                    </div>
                </a>
            </div>
        </div>
    </router-link>
</template>

<script>
import router from '@/router';
import Api from '@/services/Api'


export default {
    name: 'ReportMenuItem',
    data() {
        return {
            isFavorite: false,
            favorited_reports_ids: []
        };
    },
    props: {
        child: {
            type: Object,
            default: () => { },
        },
        show_favorite_button: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        favorite_status_changer(reportID) {
            if (this.isFavorite) {
                this.delete_favorite_report(reportID)
            }
            else {
                this.set_favorite_report(reportID)
            }
            this.isFavorite = !this.isFavorite
        },
        //favorilere ekleme
        set_favorite_report(reportID) {
            let send_data = {
                'report_id': reportID
            }
            Api.post(this, 'ats/favorite_report', send_data).then(response => {
                if (response.status) {
                    this.favorited_reports_ids.push(reportID)
                    localStorage.setItem('favorite_reports', JSON.stringify(this.favorited_reports_ids))
                    this.$emit('favorite_reports_changed')

                    this.$swal.fire({
                        position: 'top-right',
                        toast: true,
                        animation: true,
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false,
                        type: 'success',
                        title: this.$t('added_to_favorites'),
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    });
                } else {
                    this.$swal.fire(
                        this.$t('swal_warning_title'),
                        response.err ? response.err : this.$t('swal_error_text'),
                        'warning')
                }
            })
        },
        //favorilerden silme
        delete_favorite_report(reportID) {
            let send_data = {
                'report_id': reportID
            }
            Api.delete('ats/favorite_report', send_data).then(response => {
                if (response.status) {
                    this.favorited_reports_ids = this.favorited_reports_ids.filter(item => item != reportID)
                    localStorage.setItem('favorite_reports', JSON.stringify(this.favorited_reports_ids))
                    this.$emit('favorite_reports_changed')

                    this.$swal.fire({
                        position: 'top-right',
                        toast: true,
                        animation: true,
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false,
                        type: 'error',
                        title: this.$t('removed_from_favorites'),
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    });
                } else {
                    this.$swal.fire(
                        this.$t('swal_warning_title'),
                        response.err ? response.err : this.$t('swal_error_text'),
                        'warning')
                }
            })
        },
        // Yıldız Butonu Durumunu Belirle
        is_favorited() {
            this.favorited_reports_ids = JSON.parse(localStorage.getItem('favorite_reports'))
            if (this.favorited_reports_ids.includes(this.child.report_id)) {
                this.isFavorite = true
            }
        },
    },
    created() {
        this.is_favorited();
    }
};
</script>
